import { createContext, useContext } from 'react'
import { getStatusMeta } from './dummy'

/// Signals whether the shared work-order UI is currently rendering
/// the Tasks module (`true`) or the Work Orders module (`false`).
/// The two share the same page component, drawer, and views — this
/// context is how the leaf components learn which module they're in
/// without having to thread a prop through every intermediate layer.
///
/// Defaults to `false` so a component rendered outside a provider
/// (e.g., in Storybook) still gets sensible work-order copy.
const WorkModuleContext = createContext<boolean>(false)

export function WorkModuleProvider({
  isTask, children,
}: { isTask: boolean; children: React.ReactNode }) {
  return (
    <WorkModuleContext.Provider value={isTask}>
      {children}
    </WorkModuleContext.Provider>
  )
}

export function useIsTaskModule(): boolean {
  return useContext(WorkModuleContext)
}

/// Convenience hook — reads the module context and returns the
/// status meta with the correct terminal-success label. Prefer this
/// at leaf components; for loops call `getStatusMeta(status, isTask)`
/// directly with the value captured once at the component top.
export function useStatusMeta(status: string) {
  const isTask = useIsTaskModule()
  return getStatusMeta(status, isTask)
}
